import { type QueryHookOptions, useQuery } from "@apollo/client";
import { InstanceQuery } from "../graphql/queries";
import type { InstanceQueryType } from "@/types/graphql/partner.generated";

/**
 * Возможности инстанса: провайдер домена, эфиры, провайдер видео и
 * платёжные провайдеры развёртывания. Значения не зависят ни от
 * организации, ни от платформы и за сессию не меняются, поэтому кеш
 * Apollo по умолчанию (cache-first) здесь и нужен: запрос уходит один
 * раз, а все карточки читают его из кеша.
 */
export const useInstanceQuery = (
  options?: QueryHookOptions<InstanceQueryType>
) => {
  return useQuery<InstanceQueryType>(InstanceQuery, options);
};
